(function () {
  function setupEmailSubscription(containerClass = "") {
    const form = document.querySelector(
      `${containerClass} .bbl-email-subscription form`,
    );
    const emailInput = document.querySelector(
      `${containerClass} .bbl-email-subscription_input`,
    );
    const aggreeCheckbox = document.querySelector(
      `${containerClass} #bbl-email-subscription_checkbox`,
    );
    const state = document.querySelector(
      `${containerClass} .bbl-email-subscription_state`,
    );

    form.addEventListener("submit", onSubmit);

    async function onSubmit(e) {
      e.preventDefault();

      if (!aggreeCheckbox?.checked) {
        setState(
          "To proceed, please agree to the Terms of Use and Privacy Policy.",
          "red",
        );
        return;
      }

      const email = emailInput.value.trim();

      setState("Submitting...", "currentColor");

      const result = await send(email);

      if (!result.ok) {
        setState(result.message, "red");
        return;
      }

      setState("Thank you!", "green");
    }

    async function send(email) {
      try {
        const response = await fetch(
          "https://bambulab.com/api/v1/user-service/guest/email",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email,
              area: "en",
              tag: "officialblog",
              url: window.location.href,
            }),
          },
        );

        const responseJson = response.headers
          .get("content-type")
          ?.startsWith("application/json")
          ? await response.json()
          : {};

        if (response.status !== 200) {
          return {
            ok: false,
            message: responseJson.error || "There is something wrong.",
          };
        }

        return { ok: true };
      } catch (e) {
        return { ok: false, message: e.message };
      }
    }

    function setState(text, color) {
      state.textContent = text;
      state.style.color = color;
    }
  }

  window.setupEmailSubscription = setupEmailSubscription;

  setupEmailSubscription();
})();
